import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { mediaUrl, baseURL } from '../../axiosInterceptor/axiosInterceptorC';

// Create the context
export const RoleContext = createContext();

export const RoleProvider = ({ children}) => {
    const [roleval, setRoleval] = useState(localStorage.getItem('roleval') || '');
    const [gettokenval, settokenval] = useState(localStorage.getItem('jwtToken') || '');
    const [userDetails, setUserDetails] = useState(null);
    const [CompletedProperties, setCompletedProperties] = useState(0);
    const [PendingProperties, setPendingProperties] = useState(0);
    const [data, setData] = useState([]);
    const login_id = localStorage.getItem('login_id'); // Retrieve once for efficiency
    const companyName = localStorage.getItem('companyName');
    const [isLoading, setIsLoading] = useState(false);

    // Function to fetch user details
    const fetchUserDetails = async () => {
        if (!login_id) return; // Prevent unnecessary API call

        try {
            const response = await axios.post(`${baseURL}/fetchuserdetailsid`, {
                login_id: login_id,
            });

            if (response.data.userdetails.length > 0) {
                const userdetails = response.data.userdetails[0];
                setUserDetails(userdetails);
                updateRole(userdetails.role); // Update role from API response
            }
        } catch (error) {
            console.error("Error fetching user details:", error);
        }
    };

    // Function to fetch property details
    const fetchPropertyDetails_get = async (Pstatus) => {
        if (!login_id) return; // Prevent unnecessary API call

        try {
            const response = await axios.post(`${baseURL}/fetchPropertyDetails_get`, {
                login_id: login_id,
                Pstatus: Pstatus,
            });

            setCompletedProperties(response.data.completedCount[0]?.total_properties || 0);
            setPendingProperties(response.data.pendingdCount[0]?.total_properties || 0);
        } catch (error) {
            console.error("Error fetching property details:", error);
        }
    };

    // Function to fetch all properties
    const fetchpropertydetails = async () => {
        setIsLoading(true); 
        setData([]); 
        try {
            const response = await axios.get(`${baseURL}/allProperties`, {
                params: {
                    loginId: localStorage.getItem('login_id'),
                    districtval: localStorage.getItem('districtval'),
                },
            });
    
            if (response.data && response.data.length > 0) {
                setData([...response.data]);
            } else {
                setData([]); // Ensure state is updated even if empty
            }
        } catch (error) {
            console.error("Error fetching property details:", error);
        } finally {
            setIsLoading(false);  // Stop loading
        }
    };
    

    // Function to update role and sync with localStorage
    const updateRole = (newRole) => {
        localStorage.setItem('roleval', newRole);
        setRoleval(newRole);
    };

    // Fetch data when companyName changes
    useEffect(() => {
        fetchUserDetails();
        fetchPropertyDetails_get(1);
        fetchpropertydetails();
    }, []); // ✅ Add companyName to dependency array
    
    return (
        <RoleContext.Provider value={{
            roleval,
            userDetails,
            updateRole,
            fetchUserDetails,
            settokenval,
            gettokenval,
            CompletedProperties,
            PendingProperties,
            setData,
            data,
            isLoading,
            fetchpropertydetails,
        }}>
            {children}
        </RoleContext.Provider>
    );
};